import { GridPattern } from '~/components/grid-pattern';
import { cn } from '~/lib/utils';

export function HeroPatternSmall({ className }: { className?: string }) {
  const pattern = [
    { x: 16, y: 17, id: 0 },
    { x: 16, y: 18, id: 1 },
    { x: 16, y: 23, id: 2 },
    { x: 16, y: 18, id: 3 },
    { x: 18, y: 18, id: 4 },
    { x: 16, y: 18, id: 5 },
    { x: 22, y: 18, id: 6 },
  ];

  return (
    <div
      className={cn('absolute inset-0  pointer-events-none z-10 mx-0 max-w-none overflow-hidden transform', className)}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-white/30 to-white/30 opacity-40 [mask-image:radial-gradient(farthest-side_at_top,white,transparent)] dark:from-zinc-900/30 dark:to-zinc-900/30 dark:opacity-100">
        <GridPattern
          width={30}
          height={30}
          x="-12"
          y="4"
          squares={pattern}
          className="absolute inset-x-0 inset-y-[-50%] h-[200%] w-full  fill-emerald-500/20 stroke-black/30 mix-blend-overlay dark:fill-emerald-500/20 dark:stroke-white/20"
        />
      </div>
    </div>
  );
}
